import { render, staticRenderFns } from "./tabsMix.vue?vue&type=template&id=5e079131&scoped=true"
import script from "./tabsMix.vue?vue&type=script&lang=js"
export * from "./tabsMix.vue?vue&type=script&lang=js"
import style0 from "./tabsMix.vue?vue&type=style&index=0&id=5e079131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e079131",
  null
  
)

export default component.exports